/** User-visible error for trip-dashboard admin requests (axios). */
export function alertAxiosError(error: unknown, fallback: string): void {
  window.alert(formatAxiosErrorMessage(error) ?? fallback)
}

export function formatAxiosErrorMessage(error: unknown): string | null {
  if (typeof error !== 'object' || error === null) {
    return null
  }

  const err = error as { response?: { data?: unknown }; message?: string }
  const data = err.response?.data

  if (data && typeof data === 'object') {
    const d = data as Record<string, unknown>

    if (typeof d.message === 'string') {
      return d.message
    }

    if (Array.isArray(d.message)) {
      const parts = d.message.filter((m): m is string => typeof m === 'string')
      if (parts.length) {
        return parts.join('\n')
      }
    }

    if (d.errors && typeof d.errors === 'object' && d.errors !== null) {
      const errors = d.errors as Record<string, unknown>
      const firstKey = Object.keys(errors)[0]
      if (firstKey) {
        const val = errors[firstKey]
        if (Array.isArray(val) && typeof val[0] === 'string') {
          return val[0]
        }
        if (typeof val === 'string') {
          return val
        }
      }
    }
  }

  if (typeof err.message === 'string' && err.message.length > 0) {
    return err.message
  }

  return null
}
